export const PLAYER_COLORS = [
  '#38bdf8',
  '#f87171',
  '#4ade80',
  '#facc15',
  '#c084fc',
  '#fb923c',
] as const;

export function colorIndexFor(owner: string, playerOrder: readonly string[]): number {
  const idx = playerOrder.indexOf(owner);
  if (idx < 0) return 0;
  return idx % PLAYER_COLORS.length;
}
